// KCC v15: Inject X close button on cart page upsell box
// Uses event delegation so dynamic re-renders don't break it.

(function () {
  'use strict';

  var STORAGE_KEY = 'kcc-cart-page-upsell-dismissed';

  function ensureCloseButton(el) {
    if (!el || el.querySelector('.kcc-upsell-close-cart-page')) return;
    var pos = window.getComputedStyle(el).position;
    if (pos === 'static') {
      el.style.position = 'relative';
    }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kcc-upsell-close-cart-page';
    btn.setAttribute('aria-label', 'Dismiss suggestions');
    btn.setAttribute('data-kcc-cart-page-close', '');
    btn.innerHTML = '<svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>';
    el.appendChild(btn);
  }

  function findUpsellContainers() {
    var selectors = [
      '.product-upsell',
      '.upsell-products',
      '[data-upsell-products]'
    ];
    var nodes = [];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (n) { nodes.push(n); });
    });
    return nodes;
  }

  function processUpsells() {
    var nodes = findUpsellContainers();
    if (nodes.length === 0) return;

    var dismissed = false;
    try { dismissed = sessionStorage.getItem(STORAGE_KEY) === '1'; } catch (e) {}

    nodes.forEach(function (n) {
      if (dismissed) {
        n.style.display = 'none';
      } else {
        ensureCloseButton(n);
      }
    });
  }

  // EVENT DELEGATION for X close (handles dynamically created buttons too)
  // Uses CAPTURE PHASE to fire before any other handler that might stop propagation
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kcc-cart-page-close]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var container = btn.closest('.product-upsell, .upsell-products, [data-upsell-products]');
    if (container) {
      container.style.display = 'none';
    }
    // Hide all instances and persist
    findUpsellContainers().forEach(function (n) { n.style.display = 'none'; });
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e2) {}
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processUpsells);
  } else {
    processUpsells();
  }

  // Re-run on cart events
  document.addEventListener('cart:refresh', processUpsells);
  document.addEventListener('cart:updated', processUpsells);

  // MutationObserver as safety net but DEBOUNCED HEAVILY
  var debounceTimer;
  var observer = new MutationObserver(function (mutations) {
    var shouldRun = false;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && (n.matches('.product-upsell') || n.matches('.upsell-products') || n.matches('[data-upsell-products]'))) {
          shouldRun = true;
          break;
        }
        if (n.querySelector && (n.querySelector('.product-upsell') || n.querySelector('.upsell-products') || n.querySelector('[data-upsell-products]'))) {
          shouldRun = true;
          break;
        }
      }
      if (shouldRun) break;
    }
    if (shouldRun) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(processUpsells, 150);
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
